/** Internal type. DO NOT USE DIRECTLY. */
type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
/** Internal type. DO NOT USE DIRECTLY. */
export type Incremental<T> =
  | T
  | {
      [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never;
    };
import type * as Types from './graphql.schema-types';

import { gql } from 'apollo-angular';
import { Injectable } from '@angular/core';
import * as Apollo from 'apollo-angular';
export * from './graphql.schema-types';
export type SupportThreadStatusFragment = {
  conversationId: string | null;
  onlineStatus: Types.SupportStatus | null;
  supportTeamId: string | null;
  supportThreadId: string | null;
  unreadCount: number | null;
  currentSupportMember: {
    avatar: string | null;
    name: string | null;
    supportMemberId: string | null;
    userId: string | null;
  } | null;
};

export type GetSupportStatusQueryVariables = Exact<{
  organizationId: string;
}>;

export type GetSupportStatusQuery = {
  getZalamoSupportThread: {
    conversationId: string | null;
    onlineStatus: Types.SupportStatus | null;
    supportTeamId: string | null;
    supportThreadId: string | null;
    unreadCount: number | null;
    currentSupportMember: {
      avatar: string | null;
      name: string | null;
      supportMemberId: string | null;
      userId: string | null;
    } | null;
  } | null;
};

export type StartSupportThreadMutationVariables = Exact<{
  organizationId: string;
  message: string;
}>;

export type StartSupportThreadMutation = {
  startSupportThread: { status: boolean | null } | null;
};

export type GetSupportMessagesQueryVariables = Exact<{
  organizationId: string;
  conversationId: string;
  offset?: number | null | undefined;
  limit?: number | null | undefined;
}>;

export type GetSupportMessagesQuery = {
  getSupportChatMessages: Array<{
    authorId: string | null;
    comment: string | null;
    date: number | null;
    type: Types.CommnetType | null;
    standaloneSupportMessageId: string | null;
  } | null> | null;
};

export type InsertSupportMessageMutationVariables = Exact<{
  message: string;
  type: Types.CommnetType;
  organizationId: string;
  standaloneSupportMessageId: string;
}>;

export type InsertSupportMessageMutation = {
  insertMessageForSupport: {
    authorId: string | null;
    comment: string | null;
    date: number | null;
    standaloneSupportMessageId: string | null;
    type: Types.CommnetType | null;
  } | null;
};

export type NewMessageFromSupportSubscriptionVariables = Exact<{
  supportThreadId: string;
}>;

export type NewMessageFromSupportSubscription = {
  messageFromSupportSent: {
    authorId: string | null;
    comment: string | null;
    date: number | null;
    standaloneSupportMessageId: string | null;
    type: Types.CommnetType | null;
  } | null;
};

export type SupportThreadUpdatedBySupportSubscriptionVariables = Exact<{
  supportThreadId: string;
}>;

export type SupportThreadUpdatedBySupportSubscription = {
  supportThreadUpdatedBySupport: {
    conversationId: string | null;
    onlineStatus: Types.SupportStatus | null;
    supportTeamId: string | null;
    supportThreadId: string | null;
    unreadCount: number | null;
    currentSupportMember: {
      avatar: string | null;
      name: string | null;
      supportMemberId: string | null;
      userId: string | null;
    } | null;
  } | null;
};

export type MarkSupportThreadAsReadMutationVariables = Exact<{
  organizationId: string;
}>;

export type MarkSupportThreadAsReadMutation = {
  markSupportThreadAsRead: { status: boolean | null } | null;
};

export const SupportThreadStatusFragmentDoc = gql`
  fragment supportThreadStatus on ZalamoSupportThread {
    conversationId
    currentSupportMember {
      avatar
      name
      supportMemberId
      userId
    }
    onlineStatus
    supportTeamId
    supportThreadId
    unreadCount
  }
`;
export const GetSupportStatusDocument = gql`
  query getSupportStatus($organizationId: ID!) {
    getZalamoSupportThread(organizationId: $organizationId) {
      ...supportThreadStatus
    }
  }
  ${SupportThreadStatusFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class GetSupportStatusGQL extends Apollo.Query<
  GetSupportStatusQuery,
  GetSupportStatusQueryVariables
> {
  document = GetSupportStatusDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const StartSupportThreadDocument = gql`
  mutation startSupportThread($organizationId: ID!, $message: String!) {
    startSupportThread(organizationId: $organizationId, initMessage: $message) {
      status
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class StartSupportThreadGQL extends Apollo.Mutation<
  StartSupportThreadMutation,
  StartSupportThreadMutationVariables
> {
  document = StartSupportThreadDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const GetSupportMessagesDocument = gql`
  query getSupportMessages(
    $organizationId: ID!
    $conversationId: ID!
    $offset: Int
    $limit: Int
  ) {
    getSupportChatMessages(
      organizationId: $organizationId
      offset: $offset
      limit: $limit
      conversationId: $conversationId
    ) {
      authorId
      comment
      date
      type
      standaloneSupportMessageId
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class GetSupportMessagesGQL extends Apollo.Query<
  GetSupportMessagesQuery,
  GetSupportMessagesQueryVariables
> {
  document = GetSupportMessagesDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const InsertSupportMessageDocument = gql`
  mutation insertSupportMessage(
    $message: String!
    $type: CommnetType!
    $organizationId: ID!
    $standaloneSupportMessageId: ID!
  ) {
    insertMessageForSupport(
      message: $message
      type: $type
      organizationId: $organizationId
      messageId: $standaloneSupportMessageId
    ) {
      authorId
      comment
      date
      standaloneSupportMessageId
      type
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class InsertSupportMessageGQL extends Apollo.Mutation<
  InsertSupportMessageMutation,
  InsertSupportMessageMutationVariables
> {
  document = InsertSupportMessageDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const NewMessageFromSupportDocument = gql`
  subscription newMessageFromSupport($supportThreadId: ID!) {
    messageFromSupportSent(supportThreadId: $supportThreadId) {
      authorId
      comment
      date
      standaloneSupportMessageId
      type
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class NewMessageFromSupportGQL extends Apollo.Subscription<
  NewMessageFromSupportSubscription,
  NewMessageFromSupportSubscriptionVariables
> {
  document = NewMessageFromSupportDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const SupportThreadUpdatedBySupportDocument = gql`
  subscription supportThreadUpdatedBySupport($supportThreadId: ID!) {
    supportThreadUpdatedBySupport(supportThreadId: $supportThreadId) {
      ...supportThreadStatus
    }
  }
  ${SupportThreadStatusFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class SupportThreadUpdatedBySupportGQL extends Apollo.Subscription<
  SupportThreadUpdatedBySupportSubscription,
  SupportThreadUpdatedBySupportSubscriptionVariables
> {
  document = SupportThreadUpdatedBySupportDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const MarkSupportThreadAsReadDocument = gql`
  mutation markSupportThreadAsRead($organizationId: ID!) {
    markSupportThreadAsRead(organizationId: $organizationId) {
      status
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class MarkSupportThreadAsReadGQL extends Apollo.Mutation<
  MarkSupportThreadAsReadMutation,
  MarkSupportThreadAsReadMutationVariables
> {
  document = MarkSupportThreadAsReadDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
